import request from '@/utils/request'

// REQ-2026-238755 开放接口管理
// 后端 WebConst.ModulePath.OPENAPI_MANAGE = "/api/openapi"，
// /api 已经在 request 的 baseURL 里，所以这里只写 /openapi。
const apiPath = '/openapi'

const openApiManageApi = {
  // ── 接口清单 ──────────────────────────────────────────
  /**
   * 对外接口清单。
   * 返回的是「线上真实注册的路由 ∪ 代码里的登记表」，每行带 state：
   *   OK           已登记且线上有
   *   UNREGISTERED 线上有但没登记 —— 要标出来提醒人去登记
   *   OFFLINE      登记了但线上已经没有这个路由
   */
  catalog() {
    return request.get(`${apiPath}/monitor/catalog`)
  },

  // ── API Key ──────────────────────────────────────────
  /**
   * Key 列表（不含明文与 hash）
   */
  keyList() {
    return request.get(`${apiPath}/key/list`)
  },
  /**
   * 新建 Key。
   * ⚠️ 明文 key 只在这次响应里出现一次，之后**再也查不到**，
   *    页面必须当场让人复制走。
   */
  keyCreate(data) {
    return request.post(`${apiPath}/key/create`, data)
  },
  /**
   * 替换完整 apiCodes 授权集、IP 白名单与备注。
   * ⚠️ ipWhitelist 传空 = 清空 = 不限 IP，不是"保持原值"。
   */
  keyUpdate(data) {
    return request.post(`${apiPath}/key/update`, data)
  },
  /**
   * 停用 Key（不可恢复，要再用就重新建）
   */
  keyDisable(id) {
    return request.post(`${apiPath}/key/disable`, { id })
  },

  // ── 调用监控 ──────────────────────────────────────────
  /**
   * 按天总览：调用量、成功率、平均耗时
   */
  statDaily(query) {
    return request.get(`${apiPath}/monitor/daily`, { params: query })
  },
  /**
   * 按接入方统计（未通过鉴权的会聚成 groupKey 为空的一组）
   */
  statByApp(query) {
    return request.get(`${apiPath}/monitor/byApp`, { params: query })
  },
  /**
   * 按接口统计（含接入方猜接口名试探出来的不存在路径）
   */
  statByPath(query) {
    return request.get(`${apiPath}/monitor/byPath`, { params: query })
  },
  /**
   * 调用明细分页
   */
  logList(query) {
    return request.get(`${apiPath}/monitor/logs`, { params: query })
  }
}

export default openApiManageApi
